// start the app
require(['app']);

// Clean up localStorage while async requests are running
if (window.localStorage) {
    var expDate = new Date();
    var removeItems = [];
    try {
        for (var l = 0; l < window.localStorage.length; l++) {
            var key = window.localStorage.key(l);
            if (key.indexOf('cachefactory.') !== -1) {
                var value = JSON.parse(window.localStorage[key]);
                if (value.expires && value.expires < expDate.valueOf()) {
                    removeItems.push(key);
                }
            }
        }
        removeItems.forEach(function (storeKey) {
            window.localStorage.removeItem(storeKey);
        });
    } catch (e) { }
}

// Global function to retrieve url parameters.
window.getParams = function() {
    var urlParams = {};
    var match;
    var pl = /\+/g; // Regex for replacing addition symbol with a space
    var search = /([^&=]+)=?([^&]*)/g;
    var decode = function(s) {
        return decodeURIComponent(s.replace(pl, ' '));
    };
    var query = window.location.search.substring(1);
    var paramString = "";

    while (match = search.exec(query)) {
        var key = decode(match[1]);
        var val = decode(match[2]);
        if (val === "")
            val = "true";
        urlParams[key] = val;
        paramString += "&" + key + "=" + val;
    }
    urlParams.paramString = paramString;
    return urlParams;
};

(function() {
    'use strict';

    function isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    function log() {
        $.ajax({
            type: "POST",
            url: dna.app.basePath + '/secure/logJsError',
            contentType: "application/json",
            data: JSON.stringify({
                route: window.location.pathname + window.location.search + window.location.hash,
                exception: 'iOS back button - refreshing page'
            })
        });
    }

    if (isIOS()) {
        window.addEventListener('pageshow', function (event) {
            if (event && event.persisted) {
                // on an iOS device the back button caches the JS state which throws off Angular and jQuery. We need a soft reload to fix this issue.
                log();
                window.location.reload();
            }
        });
    }
})();

function _dnaSetupHeader(tab) {
    var baseUrl = dna.app.baseUrl;
    var url;
    if (dna && dna.app.logoutCrossSellEnabled && dna.app.isUserAuthenticated)
        url = baseUrl + '/public/navigation?style='+tab+'&returnUrl=' + dna.app.logoutCrossSellURL;
    else
        url = baseUrl + '/public/navigation?style='+tab+'&returnUrl='+ dna.app.baseUrl;

    if ($('#HeaderRegion').children().length == 0) {
        AjaxManager.send({
            url: url,
            success: function() {
                // Show the header.
                $("#HeaderRegion").removeAttr("style");
                // Get Footer.
                AjaxManager.send({
                    url: baseUrl + '/public/footer'
                });
                if(dna) {
                    dna.app.showingSimpleHeader = (tab === 'Simple');
                }
                AjaxManager.send({
                    url: '/Banners/API/Get/106',
                    success: function () {}
                });
            }
        });
    }
}
window.dnaShowNormalHeader = function() {
    _dnaSetupHeader('Standard');
};
window.dnaShowSimpleHeader = function() {
    _dnaSetupHeader('Simple');
};

function loadScript(url, async) {
    var s = 'script',
        a = document.createElement(s),
        b = document.getElementsByTagName(s)[0];
    a.type = 'text/java'+s;
    a.src = url;
    a.async = async;
    b.parentNode.insertBefore(a,b);
}

$('html').one('dna:routeChangeSuccess', function() {
    $('.dnaFooter').removeClass('noDisplay');
    dnaShowNormalHeader();

    loadCSS(dna.app.assetsUrl + '/css/otherDna.css');

    loadCSS('https://www.ancestrycdn.com/ui/' + dna.app.ancestryUIVersion + '/css/carousel.css');
    loadCSS('https://www.ancestrycdn.com/ui/' + dna.app.ancestryUIVersion + '/css/paging.css');
    loadCSS('https://www.ancestrycdn.com/ui/' + dna.app.ancestryUIVersion + '/css/progress.css');

    loadScript('https://api.tiles.mapbox.com/mapbox.js/v2.1.7/mapbox.js', true);
    loadCSS('https://api.tiles.mapbox.com/mapbox.js/v2.1.7/mapbox.css');

    loadCSS('https://api.tiles.mapbox.com/mapbox-gl-js/v0.43.0/mapbox-gl.css');
});

define("main/main.js", function(){});

